/**
 * Tennis "Match Winner" filter uses template `match-result` (and may still be
 * `match-winner` in older paths). Feed markets can be either id — keep aliases
 * bidirectional. `match-winner` ↔ `money-line` covers basketball/football variants.
 */
export const matchesMarketFilterTemplate = (filterTemplateId: string | null, marketTemplateId: string): boolean => {
    if (filterTemplateId === null) {
        return false;
    }

    if (marketTemplateId === filterTemplateId) {
        return true;
    }

    if (filterTemplateId === 'match-winner') {
        return marketTemplateId === 'money-line' || marketTemplateId === 'match-result';
    }

    if (filterTemplateId === 'match-result') {
        return marketTemplateId === 'match-winner';
    }

    return false;
};
